var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-icon',{attrs:{"icon":_vm.icon,"no-icon":!_vm.icon && _vm.noEmptyIndent}},[(_vm.bigger)?_c('header3-prominent',[_vm._t("default")],2):_c('header4-prominent',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }